<template>
  <div class="source-item">
    <component
      v-bind="componentAttrs"
      :is="component"
      class="note-item"
    >
      <span v-html="source.label" />
    </component>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { ISource } from '~/components/ArticleFooter.vue';
  export default defineNuxtComponent({
    name: 'ArticleFooterSourceItem',
    props: {
      source: {
        type: Object as PropType<ISource>,
        required: true,
      },
    },

    computed: {
      component(): string {
        return this.source.url ? 'a' : 'span';
      },

      componentAttrs(): Record<string, any> {
        if (this.source.url) {
          return {
            target: '_blank',
            rel: 'noopener noreferrer',
            href: this.source.url,
          };
        }
        return {};
      },
    },
  });
</script>

<style lang="scss" scoped>
  .source-item {
    color: $text-color--1;
    overflow-wrap: break-word;
    @include tinyText;
  }
</style>
